import { ready } from "~/core";

ready("contentCard", ".contentCard", (contentCard) => {
  if (contentCard.classList.contains("contentCard--swiper")) {
    const slides = [...contentCard.querySelectorAll(".contentCard__slide")];
    const nextButton = contentCard.querySelector(".contentCard__next");
    const backButton = contentCard.querySelector(".contentCard__back");
    const paginators = [
      ...contentCard.querySelectorAll(".contentCard__paginator"),
    ];
    const indicator = contentCard.querySelector(".contentCard__indicator");

    let currentSlide = 0;

    const removeActive = () => {
      slides.forEach((slide) => {
        slide.classList.remove("active");
      });
      paginators.forEach((paginator) => {
        paginator.classList.remove("active");
      });
    };

    const addActive = () => {
      slides[currentSlide].classList.add("active");
      paginators[currentSlide].classList.add("active");
      indicator.innerHTML = `${currentSlide + 1} / ${slides.length}`;
    };

    const incrementCurrentSlide = () => {
      if (currentSlide < slides.length - 1) {
        currentSlide++;
      } else {
        currentSlide = 0;
      }
    };

    const decrementCurrentSlide = () => {
      if (currentSlide > 0) {
        currentSlide--;
      } else {
        currentSlide = slides.length - 1;
      }
    };

    const setCurrentSlide = (index) => {
      currentSlide = index;
    };

    const init = () => {
      nextButton.addEventListener("click", () => {
        removeActive();
        incrementCurrentSlide();
        addActive();
      });

      backButton.addEventListener("click", () => {
        removeActive();
        decrementCurrentSlide();
        addActive();
      });

      paginators.forEach((paginator, index) => {
        paginator.addEventListener("click", () => {
          removeActive();
          setCurrentSlide(index);
          addActive();
        });
      });

      addActive();
    };

    init();
  }

  if (contentCard.classList.contains("contentCard--animated")) {
    const addAnimationFlair = (feature) => {
      const graphicsContainer = feature.querySelector(".contentCard__graphics");
      const flair = feature.querySelector(".contentCard__flair");

      const timeline = new ViewTimeline({
        subject: graphicsContainer,
        axis: "block",
      });

      flair.animate(
        [
          // keyframes
          { top: "90%" },
          { top: "0%" },
        ],
        {
          fill: "both",
          timeline,
          rangeStart: "contain 0%",
          rangeEnd: "contain 100%",
        }
      );
    };

    const addAnimationTitle = (feature) => {
      const contentContainer = feature.querySelector(".contentCard__content");
      const title = feature.querySelector(".contentCard__title");
      const copy = feature.querySelector(".contentCard__copy");
      const ctas = feature.querySelector(".contentCard__ctas");

      const timeline = new ViewTimeline({
        subject: contentContainer,
        axis: "block",
      });

      let rangeEnd = window.innerWidth < 768 ? "contain 0%" : "contain 20%";
      let rangeEndCopy =
        window.innerWidth < 768 ? "contain 15%" : "contain 50%";

      title.animate(
        [
          // keyframes
          { transform: "translateX(200%)", opacity: "0" },
          { transform: "translateX(0)", opacity: "1" },
        ],
        {
          fill: "both",
          timeline,
          rangeStart: "cover 0%",
          rangeEnd,
        }
      );

      copy.animate(
        [
          // keyframes
          { opacity: "0" },
          { opacity: "1" },
        ],
        {
          fill: "both",
          duration: 5000,
          timeline,
          rangeStart: rangeEnd,
          rangeEnd: rangeEndCopy,
        }
      );

      ctas.animate(
        [
          // keyframes
          { opacity: "0" },
          { opacity: "1" },
        ],
        {
          fill: "both",
          duration: 5000,
          timeline,
          rangeStart: rangeEnd,
          rangeEnd: rangeEndCopy,
        }
      );
    };

    if (contentCard.classList.contains("contentCard--swiper")) {
      const slides = [...contentCard.querySelectorAll(".contentCard__slide")];

      slides.forEach((slide) => {
        addAnimationFlair(slide);
      });
    } else if (contentCard.classList.contains("contentCard--stacked")) {
      const containers = [
        ...contentCard.querySelectorAll(".contentCard__container"),
      ];

      containers.forEach((container) => {
        addAnimationFlair(container);
      });
    } else if (contentCard.classList.contains("contentCard--wedge")) {
      addAnimationTitle(contentCard);
    } else {
      addAnimationFlair(contentCard);
    }
  }
});
